<template>
  <MobileLayout>
    <MobileHeader :logoColor="'white'" />
    <section class="m-hero font-apercu-medium">
      <img :src="about4" alt="About" class="m-hero-image" />
      <div class="m-hero-overlay">
        <div class="m-hero-subtitle" style="line-height: 6rem;">About</div>
        <div class="m-hero-title" style="line-height: 12rem;">The Brand</div>
      </div>
    </section>

    <section class="m-text-block font-apercu-medium">
      <p style="text-align: justify;">Based in Melbourne and led by artist and designer Steven John Clark, we create high-end furniture, lighting and
objects somewhere between the useful and the unreasonable.</p>
    </section>

    <section class="m-image-block">
      <img :src="about6" alt="About Workshop" />
    </section>

    <section class="m-image-block2 m-image-block">
      <img :src="about2" alt="About Tools" />
    </section>

    <section class="m-text-block font-apercu-medium">
      <p style="text-align: justify;">We ve spent a fair bit of time arguing with limestone, asking it to do things stone probably wasnt expecting to do. From there, things tend to wander…into bronze, glass, composites and whatever else seems worth getting our
hands dirty with. There's a bit of mad scientist in us, admittedly.</p>
    </section>

    <section class="m-slider-block">
      <div class="m-slider-track">
        <div class="m-slider-item">
          <img :src="lb1" alt="Working" />
        </div>
        <div class="m-slider-item">
          <img :src="lb2" alt="Sketches" />
        </div>
        <div class="m-slider-item">
          <img :src="lb3" alt="Sketches" />
        </div>
      </div>
    </section>

    <section class="m-text-block font-apercu-medium">
      <p style="text-align: justify;">We like contradictions. Heavy things that appear to float. Rough things that feel strangely soft. We re not makingfactory-made cans of beans, all lined up nicely while little robots get on with it. That sounds terribly efficient, butwe'd rather spend the time making something with character, something f*cking brilliant.</p>
    </section>

    <section class="m-image-block" style="height: 370rem">
      <img :src="about3" alt="About Detail" />
    </section>

    <MobileFooter :mt="51" :isBorder="false" style="margin-bottom: 80rem;"/>
  </MobileLayout>
</template>

<script>
import MobileLayout from '@/components/mobile/MobileLayout.vue'
import MobileFooter from '@/components/mobile/footer.vue'
import MobileHeader from '@/components/mobile/header.vue'

const about1 = require('@/assets/about/about1.jpg')
const about2 = require('@/assets/mobile/brand/lb-top.jpg')
const about3 = require('@/assets/mobile/brand/db.jpg')
const about4 = require('@/assets/about/about4.png')
const about5 = require('@/assets/about/about5.png')
const about6 = require('@/assets/about/about6.jpg')
const lb1 = require('@/assets/mobile/brand/1.jpg')
const lb2 = require('@/assets/mobile/brand/2.jpg')
const lb3 = require('@/assets/mobile/brand/3.jpg')
const brandLogo = require('@/assets/mobile/home/logo.png')

export default {
  name: 'MobileAbout',
  components: {
    MobileLayout,
    MobileFooter,
    MobileHeader
  },
  data() {
    return {
      about1,
      about2,
      about3,
      about4,
      about5,
      about6,
	  lb1,
	  lb2,
	  lb3,
      brandLogo
    }
  }
}
</script>

<style scoped>
.m-hero {
  position: relative;
  width: 100%;
  height: 535rem;
}

.m-hero-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.m-hero-overlay {
  position: absolute;
  bottom: 40rem;
  left: 0;
  width: 100%;
  text-align: center;
  color: #fff;
  z-index: 10;
}

.m-hero-subtitle {
  font-size: 8rem;
  margin-bottom: 5rem;
  font-weight: 500;
}

.m-hero-title {
  font-size: 16rem;
  font-weight: 700;
}

.m-text-block {
  padding: 40rem 20rem;
  font-size: 8rem;
  line-height: 1.6;
  text-align: left;
}

.m-image-block {
  width: 100%;
  height: 488rem;
  margin-bottom: 8rem;
  padding: 0 14rem;
}

.m-image-block2 {
  height: 457rem;
  margin-bottom: 0rem !important;
}



.m-image-block img {
  width: 100%;
  height: 100%;
  display: block;
  object-fit: cover;
}

.m-slider-block {
  width: 100%;
  overflow: hidden;
}

.m-slider-track {
  display: flex;
  overflow-x: auto;
  padding: 0 16rem;
  gap: 10rem;
  scroll-snap-type: x mandatory;
  -webkit-overflow-scrolling: touch;
  scrollbar-width: none;
}

.m-slider-track::-webkit-scrollbar {
  display: none;
}

.m-slider-item {
  flex: 0 0 auto;
  scroll-snap-align: start;
}

.m-slider-item img {
  width: 215rem;
  height: 270rem;
  object-fit: cover;
  display: block;
}
</style>
